import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b8u198pwlc: FaireBrandEntity = {
  token: "b_b8u198pwlc",
  type: "brand",
  name: "Seattle Gummy Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/4c156b92311f2fe63fd2111115234bf6b29677c9ebd7c9e2e0b6203e147d74a9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bb0e18f70734fafef8b736e985945543d2d892c74bf9cf31cfaf2baf588873a5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4c156b92311f2fe63fd2111115234bf6b29677c9ebd7c9e2e0b6203e147d74a9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bb0e18f70734fafef8b736e985945543d2d892c74bf9cf31cfaf2baf588873a5.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 27,
  isTopShop: true,
  isInsider: true,
  description:
    "Seattle Gummy Company (SGC) offers innovative functional gummies to enhance your day. Our gummies feature high concentrations of active compounds with fast absorption and high bioavailability, ensuring immediate benefits. Our mission is to deliver premium-quality gummies that boost energy, improve health, and help you achieve your best. We aim to make wellness accessible and enjoyable through our delicious gummies, empowering you to reach your goals.\n\nSGC's Origin\n\nDr. Connie Wan, a pharmacologist, faced a challenge with her son’s reluctance to take medication. Traditional syrups and pills were difficult to administer and often not taken correctly. During a grocery trip, she noticed gummy vitamins and wondered why gummies should not be used for medications. Her colleagues agreed it was a brilliant idea, and Connie founded SGC to make medicated gummies safe and effective.\n\nAfter extensive research and lab work, Connie developed special formulas for medicated gummies that were both palatable and accurate in dosage. While awaiting FDA approval for these gummies, she recognized the potential for non-medical applications. This led to the launch of highly concentrated functional gummies in categories like Energy, Sports, and Wellness, offering a new, enjoyable way to enhance well-being and performance.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:22.701Z",
    importedBy: "entity-db-cli",
  },
};
